var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_727_8940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 161,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5742 176H61.7617L64.5234 168H66.7031L69.4609 176H67.6484L65.6445 169.828H65.582L63.5742 176ZM63.4609 172.855H67.7422V174.176H63.4609V172.855ZM75.3525 170.586C75.2979 170.396 75.221 170.228 75.1221 170.082C75.0231 169.934 74.902 169.809 74.7588 169.707C74.6182 169.603 74.4567 169.523 74.2744 169.469C74.0947 169.414 73.8955 169.387 73.6768 169.387C73.2679 169.387 72.9085 169.488 72.5986 169.691C72.2913 169.895 72.0518 170.19 71.8799 170.578C71.708 170.964 71.6221 171.435 71.6221 171.992C71.6221 172.549 71.7067 173.023 71.876 173.414C72.0452 173.805 72.2848 174.103 72.5947 174.309C72.9046 174.512 73.2705 174.613 73.6924 174.613C74.0752 174.613 74.402 174.546 74.6729 174.41C74.9463 174.272 75.1546 174.078 75.2979 173.828C75.4437 173.578 75.5166 173.283 75.5166 172.941L75.8604 172.992H73.7979V171.719H77.1455V172.727C77.1455 173.43 76.9971 174.034 76.7002 174.539C76.4033 175.042 75.9945 175.43 75.4736 175.703C74.9528 175.974 74.3564 176.109 73.6846 176.109C72.9346 176.109 72.2757 175.944 71.708 175.613C71.1403 175.28 70.6976 174.807 70.3799 174.195C70.0648 173.581 69.9072 172.852 69.9072 172.008C69.9072 171.359 70.001 170.781 70.1885 170.273C70.3786 169.763 70.6442 169.331 70.9854 168.977C71.3265 168.622 71.7236 168.353 72.1768 168.168C72.6299 167.983 73.1208 167.891 73.6494 167.891C74.1025 167.891 74.5244 167.957 74.915 168.09C75.3057 168.22 75.652 168.405 75.9541 168.645C76.2588 168.884 76.5075 169.169 76.7002 169.5C76.8929 169.828 77.0166 170.19 77.0713 170.586H75.3525ZM78.416 176V168H83.8066V169.395H80.1074V171.301H83.5293V172.695H80.1074V174.605H83.8223V176H78.416ZM91.8428 168V176H90.3818L86.9014 170.965H86.8428V176H85.1514V168H86.6357L90.0889 173.031H90.1592V168H91.8428ZM96.0762 176H93.2402V168H96.0996C96.9043 168 97.597 168.16 98.1777 168.48C98.7585 168.798 99.2051 169.255 99.5176 169.852C99.8327 170.448 99.9902 171.161 99.9902 171.992C99.9902 172.826 99.8327 173.542 99.5176 174.141C99.2051 174.74 98.7559 175.199 98.1699 175.52C97.5866 175.84 96.8887 176 96.0762 176ZM94.9316 174.551H96.0059C96.5059 174.551 96.9264 174.462 97.2676 174.285C97.6113 174.105 97.8691 173.828 98.041 173.453C98.2155 173.076 98.3027 172.589 98.3027 171.992C98.3027 171.401 98.2155 170.918 98.041 170.543C97.8691 170.168 97.6126 169.892 97.2715 169.715C96.9303 169.538 96.5098 169.449 96.0098 169.449H94.9316V174.551ZM102.171 176H100.358L103.12 168H105.3L108.058 176H106.245L104.241 169.828H104.179L102.171 176ZM102.058 172.855H106.339V174.176H102.058V172.855ZM109.021 176V168H112.177C112.781 168 113.297 168.108 113.724 168.324C114.153 168.538 114.48 168.841 114.704 169.234C114.931 169.625 115.044 170.085 115.044 170.613C115.044 171.145 114.929 171.602 114.7 171.984C114.471 172.365 114.139 172.656 113.704 172.859C113.272 173.062 112.748 173.164 112.134 173.164H110.021V171.805H111.86C112.183 171.805 112.451 171.76 112.665 171.672C112.879 171.583 113.037 171.451 113.142 171.273C113.248 171.096 113.302 170.876 113.302 170.613C113.302 170.348 113.248 170.124 113.142 169.941C113.037 169.759 112.877 169.621 112.661 169.527C112.448 169.431 112.178 169.383 111.853 169.383H110.712V176H109.021ZM113.341 172.359L115.329 176H113.462L111.517 172.359H113.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 122,
    height: 12.7083,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1951,
    y: 136.759,
    width: 77.8049,
    height: 13.4146,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0975,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1951,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2926,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2926,
    y: 72.3687,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3901,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.488,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.488,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3901,
    y: 72.3687,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.488,
    y: 72.3687,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.585,
    y: 72.3687,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.585,
    y: 88.4663,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.585,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.585,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0975,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1951,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2926,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#2E4DCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3901,
    y: 104.564,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 136.759,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0975,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0975,
    y: 136.759,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1951,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2926,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3901,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.488,
    y: 120.661,
    width: 13.4146,
    height: 13.4146,
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 72.3687,
    width: 45.6098,
    height: 13.4146,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9599 67.672H141.04C145.503 67.672 149.12 71.2895 149.12 75.7519V146.79C149.12 151.253 145.503 154.87 141.04 154.87H36.9599C32.4975 154.87 28.88 151.253 28.88 146.79V75.7519C28.88 71.2895 32.4975 67.672 36.9599 67.672Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.76
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_727_8940",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_727_8940"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_727_8940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_727_8940",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageSchedule);
export default __webpack_public_path__ + "static/media/canvas_page_schedule.ee7e7c7b78bcd8ea687116a0805f6ecd.svg";
export { ForwardRef as ReactComponent };